export default {
	title: "Fiches de service",
	goToAttendance: "Distribuer les fiches",
	consultant: "Consultant",
	medium: "Médium",
	guide: "Guide",
	startAttendance: "Démarrer le service",
	finishAttendance: "Terminer le service",
	cancel: "Annuler",
	notes: "Notes",
	addObservation: "Ajouter une observation",
	observation: "Observation",
	attendanceCard: "Carte de présence",
	pendingTickets: "Fiches en attente",
	status: {
		PENDING: "En attente",
		IN_PROGRESS: "En cours",
		COMPLETED: "Terminé",
		CANCELLED: "Annulé",
	},
	cancelledAt: "Annulé le",
	confirmStatusChange: "Confirmer le changement de statut",
	createdAt: "Créé le",
	deleteConfirmation: "Êtes-vous sûr de vouloir supprimer la fiche {code} ?",
	finishedAt: "Terminé le",
	noTicketsDescription: "Cette personne n'a pas encore de fiches de présence",
	noTicketsFound: "Aucune fiche trouvée",
	notAssigned: "Non attribué",
	print: "Imprimer",
	startedAt: "Démarré le",
	statusChangeConfirmation: "Voulez-vous changer le statut de la fiche {code} en {status} ?",
	statusLabel: "Statut",
	ticketDetails: "Détails de la fiche",
	timeline: {
		daysSinceLastVisit: "jours sans présence",
		startedIn: "Commencé le",
		today: "Aujourd'hui",
	},
	messages: {
		ticketCreated: "Fiche {code} créée avec succès",
		ticketUpdated: "Fiche mise à jour avec succès",
		ticketCancelled: "Fiche annulée",
		ticketDeleted: "Fiche supprimée avec succès",
		statusUpdated: "Statut de la fiche mis à jour",
		loadError: "Erreur lors du chargement des fiches",
		observationAdded: "Observation mise à jour avec succès",
		errorFetching: "Erreur lors du chargement des fiches",
		errorUpdating: "Erreur lors de la mise à jour de la fiche",
	},
	table: {
		headers: {
			code: "Code",
			consultant: "Consultant",
			medium: "Médium",
			attendanceCard: "Carte de présence",
			guide: "Guide",
			status: "Statut",
		},
	},
	personAttendances: {
		title: "Consultations",
		received: "Reçues",
		given: "Réalisées",
		timeline: "Chronologie",
		list: "Liste",
	},
	mediumAttendances: {
		title: "Consultations réalisées",
		exportPdf: "Exporter en PDF",
		pdfError: "Erreur lors de la génération du PDF des consultations",
		empty: "Aucune consultation trouvée sur la période",
		filters: {
			thisYear: "Cette année",
		},
		kpis: {
			attendances: "Consultations",
			rituals: "Rituels",
			totalTime: "Temps total",
			avgTime: "Temps moyen",
		},
		table: {
			date: "Date",
			ritual: "Rituel",
			duration: "Durée",
		},
	},
};
